// Azure AD反映時に変更しました
import axios from 'axios';
import { Auth } from 'aws-amplify';
import URL from '@/common/routes/Url';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-type': 'application/json',
  },
});

instance.interceptors.request.use(async (config) => {
  const token = (await Auth.currentSession()).getIdToken().getJwtToken();
  if (!token) {
    throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
  }
  if (config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

instance.interceptors.response.use(
  (response) =>
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = URL.signin;
    }
    return Promise.reject(error);
  },
);
export default instance;
